import {Box, Spinner} from "@chakra-ui/react";
import Logo from "../../layout/Logo";

const Loader = () => {
    return (
        <Box display={'flex'} w={'100vw'} h={'100vh'} bg={'surface.page'} justifyContent={'center'} alignItems={'center'}
             flexDirection={'column'} rowGap={8}>
            <Logo />
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='surface.border'
                color='brand.500'
                size='lg'
            />
        </Box>
    )
}

export default Loader;
